class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartOffcanvas = document.querySelector('header-cart-dropdown');
  }
  
  onSubmitHandler(evt) {
    evt.preventDefault();
    this.handleErrorMessage();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
  
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections_url: window.location.pathname
    });
    
    // const body = JSON.stringify({
    //   ...JSON.parse(serializeForm(this.form)),
    //   sections_url: window.location.pathname
    // });
    
    const ADDTOCARTURL = `${routes.cart_add_url}.js`;
    fetch(ADDTOCARTURL, config)
      .then((response) => response.json())
      .then(async (parsedState) => {
        if (parsedState.status) {
          this.handleErrorMessage(parsedState.description);
          return;
        }
        const cartData = await this.getCartData();
        this.cartOffcanvas.renderContents(cartData);
        // 加入成功打开侧边栏购物车
        UIkit.offcanvas(this.cartOffcanvas).show();
      })
      .catch((e) => {
        console.error(e);
        UIkit.offcanvas(this.cartOffcanvas).hide();
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
  
  /**
   * 购买数量超过库存时错误信息
   * @param errorMessage
   */
  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('[data-error-message-wrapper]');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('[data-error-message]');
    
    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    
    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
  
  /**
   * 返回最新购物车数据
   * @returns {Promise<any>}
   */
  async getCartData() {
    const body = JSON.stringify({
      sections: this.cartOffcanvas.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    
    return await fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}})
      .then((response) => {
        return response.text();
      })
      .then((parsedState) => {
        return JSON.parse(parsedState);
      })
  }
}

customElements.define('product-form', ProductForm);
